
import axios from 'axios'
import config from '../config'
import auth from './auth'
export default {

    getTokenInfo(token) {
        return axios.get(`apto-medico/${token}`)
    },



    getAptoByEventoAndId(evento_id, id) {
        return axios.get(`${config.api_base_url}evento/${evento_id}/aptos-medicos/${id}`)
    },

    getAptos(evento_id, filters){

        let params =  new URLSearchParams(filters).toString();
        params = params ? `?${params}` : '';
        return axios.get(`${config.api_base_url}evento/${evento_id}/aptos-medicos${params}`)
            .then((res) => {return res.data})
            .catch(res=>{                 
                if(res.response){                   
                    if(res.response.status == 401){
                        auth.logout();
                    }else{
                        throw res;                
                    }
                }else{
                    throw res;
                }
            }); 
    },

    rechazarAptoMedico(aptomedico_id, data){
        return axios.post(`aptos-medicos/${aptomedico_id}/rechazar`, data)
            .then((res) => res)
            .catch(error =>{ 
                console.log(error);
                throw error;
            });
    },

    aprobarAptoMedico(aptomedico_id, data){
        return axios.post(`aptos-medicos/${aptomedico_id}/aceptar`, data)
            .then((res) => res)
            .catch(error =>{ 
                console.log(error);
                throw error;
            });
    },



    /******************* */
    getAptosNoEnviados(evento_id, filters){

        let params =  new URLSearchParams(filters).toString();
        params = params ? `?${params}` : '';
        return axios.get(`${config.api_base_url}evento/${evento_id}/aptos-medicos-no-enviados${params}`)
            .then((res) => {return res.data})
            .catch(res=>{                 
                if(res.response){                   
                    if(res.response.status == 401){
                        auth.logout();
                    }else{
                        throw res;                
                    }
                }else{
                    throw res;
                }
            }); 
    },

    enviarEmail(evento_id, token){
        return axios.post(`${config.api_base_url}evento/${evento_id}/aptos-medicos/${token}/enviar-email`)
            .then((res) => {return res.data})
            .catch(res=>{                 
                if(res.response){                   
                    if(res.response.status == 401){
                        auth.logout();
                    }else{
                        throw res;                
                    }
                }else{
                    throw res;
                }
            }); 
    },

    queueSendEmailsJob(evento_id){
        return axios.post(`${config.api_base_url}evento/${evento_id}/aptos-medicos/send-massive-reminder`)
            .then((res) => {return res.data})
            .catch(res=>{                 
                if(res.response){                   
                    if(res.response.status == 401){
                        auth.logout();
                    }else{
                        throw res;                
                    }
                }else{
                    throw res;
                }
            }); 
    }
  

}